import { render, staticRenderFns } from "./PropertyProductManagementEdit.vue?vue&type=template&id=ecd4ffae&scoped=true&"
import script from "./PropertyProductManagementEdit.vue?vue&type=script&lang=js&"
export * from "./PropertyProductManagementEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd4ffae",
  null
  
)

export default component.exports